import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
    mode:"history",
    routes: [
        // {
        //     path: '/',
        //     redirect: '/',
        // },
        {
            path: '/Main',
            name: 'Main',
            component: () => import('../view/query.vue')
        },
        {
            path: '/',
            name: 'certificate',
            component: () => import('../view/certificate.vue')
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js